import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { buscarProveedores } from '../../../actions/proveedores';
import { buscarOrdenes, filtrarOrdenes } from '../../../actions/ordenes';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const FiltrosOrden = () => {

    const dispatch =  useDispatch();

    const { ventana_filtros_listado } = useSelector(state => state.ordenes);
    const { listado: listado_proveedores } = useSelector(state => state.proveedores);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const statusFilter = [
        { value: 1, label: 'Pendiente' },
        { value: 2, label: 'Finalizada' },
        { value: 3, label: 'Cancelada' }
    ];

    const statusDefault = statusFilter.filter(item => item.value == 1 || item.value == 2);

    const [filtrosData, setFiltrosData] = useState({
        proveedor: null,
        fecha_inicio: null,
        fecha_fin: null,
        status: statusDefault.map(item => item.value)
    });

    const [proveedorData, setProveedorData] = useState(null);
    const [proveedoresFilter, setProveedoresFilter] = useState([]);

    const [statusData, setStatusData] = useState(statusDefault);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible",
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Filtros */
    const handleAbrir = () => {
        dispatch(buscarProveedores());
    }

    const handleSelectProveedor = (option) => {
        setFiltrosData({
            ...filtrosData,
            proveedor: option ? option.value : null
        });

        setProveedorData(option);
    }

    const handleSelectStatus = (option) => {
        setFiltrosData({
            ...filtrosData,
            status: option?.length > 0 ? option.map(item => item.value) : null
        });

        setStatusData(option || []);
    }

    const handleDatePicker = (name, value) => {
        setFiltrosData({
            ...filtrosData,
            [name]: value
        });
    }

    const handleProcesar = async (limpiar) => {
        await setStatusProcesar(true);

        if(!limpiar){
            await dispatch(buscarOrdenes(filtrosData));
        }else{
            let datos_base = {
                ...filtrosData,
                proveedor: null,
                fecha_inicio: null,
                fecha_fin: null,
                status: statusDefault.map(item => item.value)
            };

            await dispatch(buscarOrdenes(datos_base));

            await setFiltrosData(datos_base);

            await setProveedorData(null);
            await setStatusData(statusDefault);
        }

        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            dispatch(filtrarOrdenes(false));
        }
    }

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_proveedores?.length; i++) {
            options.push({ value: listado_proveedores[i].id, label: listado_proveedores[i].alias ? listado_proveedores[i].alias + ' (' + listado_proveedores[i].razon_social + ')' : listado_proveedores[i].razon_social });
        }

        setProveedoresFilter(options);
    }, [listado_proveedores]);

    return (
        <Modal show={ventana_filtros_listado} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Filtrar órdenes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="proveedor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Proveedor"
                                options={proveedoresFilter}
                                value={proveedorData}
                                isClearable={true}
                                onChange={(value) => handleSelectProveedor(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={statusFilter}
                                value={statusData}
                                isClearable={true}
                                isMulti={true}
                                onChange={(value) => handleSelectStatus(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_inicio ? new Date(filtrosData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha inicial</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_fin ? new Date(filtrosData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha final</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-secondary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-secondary" onClick={() => handleProcesar(true)}><i className="fas fa-trash fa-sm"></i> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-search fa-sm"></i> Buscar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosOrden;
